<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Basic-Paragraph">Copyright © 2015</p>
<p class="P_Basic-Paragraph">By Dan Helpingstine</p>
<p class="P_Basic-Paragraph__And__Spacing_After">All rights reserved</p>
<p class="P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment__And__Spacing_After"><span> </span></p>
<p class="P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment__And__Spacing_After"><span>The word “Pelican” and the depiction of a pelican are</span></p>
<p class="P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment__And__Spacing_After"><span>trademarks of Pelican Publishing Company, Inc., and are</span></p>
<p class="P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment__And__Spacing_After"><span>registered in the U.S. Patent and Trademark Office.</span></p>
<p class="P_Basic-Paragraph__And__Spacing_After"> </p>
<p class="P_Basic-Paragraph__And__Spacing_After">Library of Congress Cataloging-in-Publication Data</p>
<p class="P_Basic-Paragraph__And__Spacing_After"> </p>
<p class="P_Basic-Paragraph__And__Spacing_After">Helpingstine, Dan.</p>
<p class="P_Basic-Paragraph__And__Spacing_After">Dallas forever changed : the legacy of November 1963 / by Dan Helpingstine.</p>
<p class="P_Basic-Paragraph__And__Spacing_After">pages cm</p>
<p class="P_Basic-Paragraph__And__Spacing_After">Includes bibliographical references and index.</p>
<p class="P_Basic-Paragraph__And__Spacing_After">ISBN 978-1-4556-2054-8 (hardcover : alk. paper) -- ISBN 978-1-4556-2055-5 (e-book) 1. Kennedy, John F. (John Fitzgerald), 1917-1963--Assassination. 2. Presidents--Assassination--United States--Psychological aspects. 3. Stigma (Social psychology)--Texas--Dallas. 4. Group identity--Texas--Dallas. 5. Dallas (Tex.)--Civilization. I. Title.</p>
<p class="P_Basic-Paragraph__And__Spacing_After">E842.9.H393 2015</p>
<p class="P_Basic-Paragraph__And__Spacing_After">976.4’2812063--dc23</p>
<p class="P_Basic-Paragraph__And__Centre_Alignment__And__Spacing_After"><span>2015001047</span></p>
<p class="P_div_frame-2__And__Left_Alignment__And__Spacing_After"> </p>
<p class="P_div_frame-2__And__Left_Alignment__And__Spacing_After"> </p>
<p class="P_div_frame-2__And__Left_Alignment__And__Spacing_After"><img alt="" src="image1.jpg" style=" max-width: 100%; max-height: 100%;"/></p>
<p class="P_Basic-Paragraph_para-style-override-6__And__Spacing_After">Printed in the United States of America</p>
<p class="P_Basic-Paragraph__And__Spacing_After">Published by Pelican Publishing Company, Inc.</p>
<p class="P_Basic-Paragraph_para-style-override-7__And__Spacing_After">1000 Burmaster Street, Gretna, Louisiana 70053</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?7c85e932